import { Modal, Button, Nav } from "react-bootstrap";
import { useState } from "react";
import LeadBasicInfoTab from "./company-tabs/contact-tabs/LeadBasicInfoTab ";
import LeadAddressTab from "./company-tabs/contact-tabs/LeadAddressTab";
import LeadSocialProfileTab from "./company-tabs/contact-tabs/LeadSocialProfileTab";
import LeadAccessTab from "./company-tabs/contact-tabs/LeadAccessTab";


// import BasicInfoTab from "../contact-tabs/BasicInfoTab";
// import SocialProfileTab from "../contact-tabs/SocialProfileTab";
// import AccessTab from "../contact-tabs/AccessTab";
// import AddressTab from "../contact-tabs/AddressTab";

const AddContactModal = ({ show, handleClose, onHide }) => {
  const close = handleClose || onHide;

  const [activeTab, setActiveTab] = useState("basic");

  return (
    <>
      <Modal
        show={show}
        onHide={close}
        backdrop="static"
        centered
        size="lg"
        className="contacts-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Contact</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* TABS */}
          <Nav className="custom-tabs">
            <Nav.Item>
              <Nav.Link
                className={activeTab === "basic" ? "active" : ""}
                onClick={() => setActiveTab("basic")}
              >
                Basic Information
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                className={activeTab === "address" ? "active" : ""}
                onClick={() => setActiveTab("address")}
              >
                Address
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                className={activeTab === "social" ? "active" : ""}
                onClick={() => setActiveTab("social")}
              >
                Social Profiles
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                className={activeTab === "access" ? "active" : ""}
                onClick={() => setActiveTab("access")}
              >
                Access
              </Nav.Link>
            </Nav.Item>
          </Nav>

          {/* CONTENT */}
          <div className="tab-content-area mt-3">
            {activeTab === "basic" && <LeadBasicInfoTab />}
            {activeTab === "address" && <LeadAddressTab />}
            {activeTab === "social" && <LeadSocialProfileTab />}
            {activeTab === "access" && <LeadAccessTab />}
          </div>

          {/* FOOTER */}
          <div className="footer-actions">
            <Button variant="light" onClick={close}>
              Cancel
            </Button>
            <Button className="btn-orange">Save</Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* STYLES */}
      <style>{`
        .contacts-modal .modal-content {
          border-radius: 10px;
        }

        /* TABS */
        .custom-tabs {
          border-bottom: 1px solid #eee;
          gap: 10px;
        }

        .custom-tabs .nav-link {
          border: none;
          color: #6b7280;
          font-weight: 500;
          padding: 10px 12px;
          position: relative;
        }

        .custom-tabs .nav-link.active {
          color: #ff6b2c;
        }

        .custom-tabs .nav-link.active::after {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #ff6b2c;
        }

        /* FOOTER */
        .footer-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          margin-top: 20px;
        }

        /* BUTTON */
        .btn-orange {
          background: #ff6b2c !important;
          border: none !important;
          color: white !important;
        }

        .btn-orange:hover {
          background: #e65a1f !important;
        }

        /* INPUTS */
        input, select, textarea {
          border-radius: 6px !important;
        }

        /* SELECT ORANGE */
        select:focus {
          border-color: #ff6b2c !important;
          box-shadow: 0 0 0 0.2rem rgba(255,107,44,0.2) !important;
        }

        /* DROPDOWN SELECTED */
        option:checked {
          background: #ff6b2c !important;
          color: white;
        }

        /* MOBILE */
        @media (max-width:768px){
          .footer-actions {
            flex-direction: column;
          }

          .custom-tabs {
            overflow-x: auto;
            white-space: nowrap;
          }
        }
      `}</style>
    </>
  );
};

export default AddContactModal;
